module.exports = __webpack_public_path__ + "static/img/jssmbj_icon.png";